import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
export function OutletOnboarding() {
  const navigate = useNavigate();
  const {
    t
  } = useTranslation('common');
  const [step, setStep] = useState(1);
  const steps = [{
    id: 1,
    name: 'Profile & Location'
  }, {
    id: 2,
    name: 'Business Details (KYB)'
  }, {
    id: 3,
    name: 'Settlement & Channels'
  }, {
    id: 4,
    name: 'Review'
  }];
  return <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-7735">
      <button onClick={() => navigate('/outlets/directory')} className="flex items-center text-sm text-gray-500 hover:text-gray-700 mb-6 transition-colors" data-id="element-7736">
        <ArrowLeftIcon size={16} className="mr-1" data-id="element-7737" />
        Back to Directory
      </button>

      <div className="mb-8" data-id="element-7738">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-7739">Add New Outlet</h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-7740">
          Onboard a new sub-merchant to a property
        </p>
      </div>

      {/* Stepper */}
      <nav aria-label="Progress" className="mb-8" data-id="element-7741">
        <ol role="list" className="flex items-center" data-id="element-7742">
          {steps.map((s, stepIdx) => <li key={s.name} className={`relative ${stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20' : ''}`} data-id="element-7743">
              {s.id < step ? <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-7744">
                    <div className="h-0.5 w-full bg-[var(--brand-primary)]" data-id="element-7745" />
                  </div>
                  <div className="relative flex h-8 w-8 items-center justify-center rounded-full bg-[var(--brand-primary)] hover:bg-[var(--brand-primaryhover)]" data-id="element-7746">
                    <CheckIcon className="h-5 w-5 text-[var(--brand-primarytextonwhite)]" aria-hidden="true" data-id="element-7747" />
                  </div>
                </> : s.id === step ? <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-7748">
                    <div className="h-0.5 w-full bg-gray-200" data-id="element-7749" />
                  </div>
                  <div className="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-[var(--brand-primary)] bg-white" aria-current="step" data-id="element-7750">
                    <span className="h-2.5 w-2.5 rounded-full bg-[var(--brand-primary)]" data-id="element-7751" />
                  </div>
                </> : <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-7752">
                    <div className="h-0.5 w-full bg-gray-200" data-id="element-7753" />
                  </div>
                  <div className="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400" data-id="element-7754">
                    <span className="h-2.5 w-2.5 rounded-full bg-transparent" data-id="element-7755" />
                  </div>
                </>}
            </li>)}
        </ol>
      </nav>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-8" data-id="element-7756">
        {step === 1 && <div className="space-y-6" data-id="element-7757">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-7758">
              Profile & Location
            </h2>
            <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2" data-id="element-7759">
              <div className="sm:col-span-2" data-id="element-7760">
                <label className="block text-sm font-medium text-gray-700" data-id="element-7761">
                  Outlet Name
                </label>
                <div className="mt-1" data-id="element-7762">
                  <input type="text" className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-7763" />
                </div>
              </div>
              <div data-id="element-7764">
                <label className="block text-sm font-medium text-gray-700" data-id="element-7765">
                  Category
                </label>
                <div className="mt-1" data-id="element-7766">
                  <select className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-7767">
                    <option data-id="element-7768">F&B</option>
                    <option data-id="element-7769">Retail</option>
                    <option data-id="element-7770">Luxury</option>
                    <option data-id="element-7771">Services</option>
                    <option data-id="element-7772">Entertainment</option>
                  </select>
                </div>
              </div>
              <div data-id="element-7773">
                <label className="block text-sm font-medium text-gray-700" data-id="element-7774">
                  Mall / Property
                </label>
                <div className="mt-1" data-id="element-7775">
                  <select className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-7776">
                    <option data-id="element-7777">Saujana Sentral KL</option>
                    <option data-id="element-7778">Saujana Damansara</option>
                  </select>
                </div>
              </div>
              <div data-id="element-7779">
                <label className="block text-sm font-medium text-gray-700" data-id="element-7780">
                  Floor / Zone
                </label>
                <div className="mt-1" data-id="element-7781">
                  <input type="text" className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-7782" />
                </div>
              </div>
              <div data-id="element-7783">
                <label className="block text-sm font-medium text-gray-700" data-id="element-7784">
                  Floor Area (sqft)
                </label>
                <div className="mt-1" data-id="element-7785">
                  <input type="number" className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-7786" />
                </div>
              </div>
            </div>
          </div>}

        {step > 1 && <div className="py-12 text-center" data-id="element-7787">
            <p className="text-gray-500" data-id="element-7788">Step {step} content goes here.</p>
          </div>}

        <div className="mt-8 pt-5 border-t border-gray-200 flex justify-end gap-3" data-id="element-7789">
          {step > 1 && <button type="button" onClick={() => setStep(step - 1)} className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-7790">
              Back
            </button>}
          <button type="button" onClick={() => {
          if (step < 4) setStep(step + 1);else navigate('/outlets/directory');
        }} className="bg-[var(--brand-primary)] py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-[var(--brand-primarytextonwhite)] hover:bg-[var(--brand-primaryhover)]" data-id="element-7791">
            {step === 4 ? 'Submit' : 'Next'}
          </button>
        </div>
      </div>
    </div>;
}